export const environment = {
    production: false,
    BASEURL: 'https://server.metabarcoding.com/',
    USERSNAP_SPACE_KEY: 'be748c59-e403-4fc0-b1aa-d3456b65ed73',
    USERSNAP_APP_VERSION: '1.0.1',
    USERSNAP_BUG_WIDGET_KEY: '33b7759f-75cb-4b4c-bbc4-005c3fbbc6f9',
    USERSNAP_NAME: 'prod'
};
